// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /team/injuries-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeTeamInjuriesGetBody,
  typeTeamInjuriesGetOutput200,
} from "../../sdk/team/postTeamInjuriesGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildTeamInjuriesGetQueryKey(
  payload: typeTeamInjuriesGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  return ["post:team:teamInjuriesGet", "svc:sports-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeTeamInjuriesGetOutput200,
    unknown,
    typeTeamInjuriesGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useTeamInjuriesGet(
  payload: typeTeamInjuriesGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildTeamInjuriesGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postTeamInjuriesGet(payload),
    ...resolvedOptions,
  });
}
